export { LoadingAlert as default, LoadingAlert } from './loading-alert';

